/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentAutomations/AutomationsList/Content/Empty"
  
}) {
let dtSpaceXxl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxl'
        })
  return (<React.Fragment
>
<div
  data-testid="Empty.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-4PwO0': typeof dtSpaceXxl === 'number' ? `${dtSpaceXxl}px` : dtSpaceXxl}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 text="No automations found."
/>
</div>
{children}
</React.Fragment>)
}